import { render, staticRenderFns } from "./PayIndex.vue?vue&type=template&id=4685d806&"
import script from "./PayIndex.vue?vue&type=script&lang=js&"
export * from "./PayIndex.vue?vue&type=script&lang=js&"
import style0 from "./PayIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports